import { AlertTriangle, Lock } from 'lucide-react';
import { classerErreur, REFUS } from '@/shared/api/erreurs';

/**
 * L'erreur d'UN bloc, affichée DANS ce bloc.
 *
 * La page avait une seule bannière rouge en tête, partagée par huit gestes : un échec
 * de révocation s'annonçait au-dessus du contrat, loin de la clé concernée, et le
 * message suivant l'écrasait. Chaque bloc porte désormais la sienne.
 *
 * `classerErreur` décide des mots : un 403 dit « vous n'avez pas accès », jamais
 * « aucune donnée » (`frontend/CLAUDE.md`, un écran ne masque pas un refus).
 */
export default function ErreurBloc({ erreur, testid }) {
  if (!erreur) return null;
  // Un texte déjà rédigé (un refus partiel sur un lot) passe tel quel.
  const { genre, titre, message } = typeof erreur === 'string'
    ? { genre: null, titre: erreur, message: '' }
    : classerErreur(erreur);
  const refus = genre === REFUS;
  const Icone = refus ? Lock : AlertTriangle;
  return (
    <div role="alert" data-testid={testid}
         className={`flex gap-2.5 rounded-md border px-3 py-2.5 text-[13px] ${refus
           ? 'border-neutral-300 bg-neutral-50 text-neutral-700'
           : 'border-red-200 bg-red-50 text-red-800'}`}>
      <Icone className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <div>
        <p className="font-medium">{titre}</p>
        {message && <p className="mt-0.5 opacity-90">{message}</p>}
      </div>
    </div>
  );
}
